import React from 'react';
import PropTypes from 'prop-types';
import {
  COUNTRY_OPTIONS,
  getStateOptions,
  stateFieldLabel
} from 'components/contacts/companies/country_state_list';
import { Col, Row, Form } from 'react-bootstrap-5';

export default function AddressFields({ address, showAddress, onChange }) {
  const countryId = address.countryId || 1;

  const stateOptions = getStateOptions(countryId || 1);

  if (!showAddress) return null;

  return (
    <React.Fragment>
      <Row>
        <Col md={6}>
          <Form.Group className="form-group">
            <Form.Label>Address Name</Form.Label>
            <input
              className="form-control"
              type="text"
              value={address.label || ''}
              onChange={e => onChange(e.target.value, 'label')}
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="form-group">
            <Form.Label>Country</Form.Label>
            <Form.Select
              value={countryId.toString()}
              onChange={e => onChange(e.target.value, 'countryId')}
            >
              {COUNTRY_OPTIONS.map(countryOption => (
                <option key={countryOption[0]} value={countryOption[1]}>{countryOption[0]}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      {address.countryId === 0 && (
        <Form.Group className="form-group">
          <Form.Label>Country Name Override</Form.Label>
          <input
            className="form-control"
            type="text"
            value={address.countryNameOverride || ''}
            onChange={e => onChange(e.target.value, 'countryNameOverride')}
          />
        </Form.Group>
      )}

      <Row>
        <Col md={6}>
          <Form.Group className="form-group">
            <Form.Label>Address Line 1</Form.Label>
            <input
              className="form-control"
              type="text"
              value={address.addressOne || ''}
              onChange={e => onChange(e.target.value, 'addressOne')}
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="form-group">
            <Form.Label>Address Line 2</Form.Label>
            <input
              className="form-control"
              type="text"
              value={address.addressTwo || ''}
              onChange={e => onChange(e.target.value, 'addressTwo')}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <Form.Group className="form-group">
            <Form.Label>City</Form.Label>
            <input
              className="form-control"
              type="text"
              value={address.city || ''}
              onChange={e => onChange(e.target.value, 'city')}
            />
          </Form.Group>
        </Col>

        <Col md={4}>
          {stateOptions.length > 0 ? (
            <Form.Group className="form-group">
              <Form.Label>{stateFieldLabel(countryId.toString())}</Form.Label>
              <Form.Select
                value={address.state || stateOptions[0][1]}
                onChange={e => onChange(e.target.value, 'state')}
              >
                {stateOptions.map(stateOption => (
                  <option key={stateOption[1]} value={stateOption[1]}>{stateOption[0]}</option>
                ))}
              </Form.Select>
            </Form.Group>
          ) : (
            <Form.Group className="form-group">
              <Form.Label>{stateFieldLabel(countryId.toString())}</Form.Label>
              <input
                className="form-control"
                type="text"
                value={address.state || ''}
                onChange={e => onChange(e.target.value, 'state')}
              />
            </Form.Group>
          )}
        </Col>

        <Col md={4}>
          <Form.Group className="form-group">
            <Form.Label>Zip</Form.Label>
            <input
              className="form-control"
              type="text"
              value={address.zip || ''}
              onChange={e => onChange(e.target.value, 'zip')}
            />
          </Form.Group>
        </Col>
      </Row>
    </React.Fragment>
  );
}

AddressFields.propTypes = {
  address: PropTypes.object.isRequired,
  showAddress: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
